export default {
    namespaced: true,
    state: {
        page_name: String(""),
        // Counts shown as pills beside the page name in the top app bar (see pageBadgesMixin.js)
        page_badges: []
    },
    mutations: {
        setPageName(state, payload) {
            state.page_name = payload
            document.title = payload ? `${payload} - GGB` : 'GGB'
        },
        setPageBadges(state, payload) {
            state.page_badges = payload || []
        }
    },
    getters: {
        getPageName: (state) => state.page_name,
        getPageBadges: (state) => state.page_badges
    },
    actions: {
        setPageNameAction( {commit}, payload ) {
            commit('setPageName', payload)
        }
    }
}
